import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from '@mui/material';
import useTitle from '../../../hooks/useTitle';

import t2w from '../../../assets/t2w.png';
import pass from '../../../assets/pass.png';
import todo from '../../../assets/todo.png';
import { Link } from 'react-router-dom';

const products = [
  {
    slug: 'pass',
    name: 'Passwort-Tool',
    description:
      'Verschicken Sie Passwörter sicher und einfach. Unser Tool verschlüsselt Ihre Passwörter noch auf Ihrem Gerät und erzeugt einen Einmallink für den Abruf.',
    image: pass,
  },
  {
    slug: 'todo',
    name: 'Todo-Tool',
    description:
      'Erzeugen Sie TANSS-Tickets und weclapp-Chancen aus einer minimalistischen Oberfläche heraus.',
    image: todo,
  },
  {
    slug: 't2w',
    name: 'Tanss2weclapp',
    description:
      'Verbinden Sie Tanss und weclapp um Rechnungen aus TANSS heraus zu erzeugen und Stammdaten zu synchronisieren.',
    image: t2w,
  },
];

export default function Products() {
  useTitle('Produkte');
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gridTemplateRows: 'repeat(3, 1fr)',
          gap: '20px',
          width: '90%',
          height: '100%',
          py: '60px',
          minHeight: 'calc(100vh - 94px)',
        }}
      >
        {products.map((product) => (
          <Card
            key={product.name}
            sx={{ display: 'flex', flexDirection: 'column' }}
          >
            <CardMedia
              component="img"
              alt={product.name}
              height="140"
              image={product.image}
              sx={{ objectFit: 'contain' }}
            />
            <CardContent sx={{ flex: 1 }}>
              <Typography gutterBottom variant="h5" component="div">
                {product.name}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {product.description}
              </Typography>
            </CardContent>
            <CardActions sx={{ pb: 2, pl: 2 }}>
              <Button
                size="small"
                component={Link}
                to={`/products/${product.slug}`}
              >
                Mehr erfahren
              </Button>
            </CardActions>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
